import { useQuery } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import type { UserGroup } from '../types/userGroup';
import customFetch from '../utils/fetch';
export const useGetUserGroupsMinified = () => {
  const {
    data,
    isLoading,
    isError,
    error
  } = useQuery({
    queryKey: ['getUserGroupsMinified'],
    queryFn: async () => {
      const response = await customFetch(`${BASE_API_URL}/user/group?minified=true`, {});
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch user groups');
      }
      const {
        data,
        success,
        error
      } = (await response.json() as {
        data: UserGroup[];
        error: string;
        success: boolean;
      });
      if (!success) {
        throw new Error(error);
      }
      return {
        groups: data
      };
    },
    retry: false
  });
  return {
    data,
    isLoading,
    isError,
    error
  };
};